import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import React from "react";

interface CancelPopPupProps {
  isVisible: boolean;
  onCancelAvort: () => void;
  onCancelConfirm: () => void;
}

const CancelPopPup: React.FC<CancelPopPupProps> = ({
  isVisible,
  onCancelAvort,
  onCancelConfirm,
}) => {
  const [open, setOpen] = React.useState(isVisible);

  const handleOpen = () => {
    setOpen(!open);
    onCancelAvort();
  };

  const handleCancelConfirm = () => {
    setOpen(!open);
    onCancelConfirm();
  };

  return (
    <>
      {open && (
        <div className="pointer-events-none fixed inset-0 z-[999] grid h-screen w-screen place-items-center bg-black bg-opacity-60 opacity-0 backdrop-blur-sm transition-opacity duration-300">
          <Dialog
            open={open}
            handler={handleOpen}
            size="xs"
            className="m-4 w-11/12 sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-1/4 min-w-[280px] max-w-[400px] rounded-lg bg-white font-sans text-base font-light leading-relaxed text-black antialiased shadow-2xl"
          >
            <DialogHeader className="text-lg md:text-xl font-semibold p-4 md:p-6">
              Êtes-vous sûr d'annuler ?
            </DialogHeader>
            <DialogBody className="text-base md:text-lg p-4 md:p-6">
              Vous allez perdre la progression
            </DialogBody>
            <DialogFooter className="flex flex-col sm:flex-row items-center justify-between gap-3 p-4 md:p-6">
              <Button
                variant="text"
                color="red"
                onClick={handleOpen}
                className="w-full sm:w-auto mr-0 sm:mr-1 bg-[#EDEDED] text-[#131CC9] text-sm md:text-base px-4 md:px-6 py-2 md:py-3"
              >
                <span>Revenir</span>
              </Button>
              <Button
                variant="gradient"
                color="green"
                onClick={handleCancelConfirm}
                className="w-full sm:w-auto bg-[#E3B505] text-[#131CC9] text-sm md:text-base px-4 md:px-6 py-2 md:py-3"
              >
                <span>Confirmer</span>
              </Button>
            </DialogFooter>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default CancelPopPup;
